<button
  class="gradient-btn"
  nz-button
  [nzSize]="'large'"
  [nzBlock]="fullSize"
  (click)="openLotWatchRequestBuyModal()"
>
  {{ 'LOT_WATCH_REQUEST_BUY_BUTTON.TITLE' | translate }}
</button>
